import { zodResolver } from '@hookform/resolvers/zod';
import { IssueCreditNoteRequestSchema } from '@vy/api-definition';
import { ObjectIdSchema } from '@vy/types';
import { oz } from '@vy/utils';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';

const CreateCreditNoteFormSchema = IssueCreditNoteRequestSchema.extend({
  customerId: ObjectIdSchema,
  netSuiteItemId: oz.string().optional(),
  quickBooksItemId: oz.string().optional(),
  xeroItemCode: oz.string().optional(),
});

export type CreateCreditNoteFormValues = oz.infer<typeof CreateCreditNoteFormSchema>;

const defaultValues: Partial<CreateCreditNoteFormValues> = {
  date: new Date(),
};

function getDefaultValues(customerId?: string, invoiceId?: string, contractId?: string) {
  return {
    ...defaultValues,
    customerId: customerId ?? defaultValues.customerId,
    invoiceId: invoiceId ?? defaultValues.invoiceId,
    contractId: contractId ?? defaultValues.contractId,
    creditInvoice: false,
  };
}

export function withCreateCreditNoteForm(Component: React.FC) {
  return (props: any) => {
    const [queryParams] = useSearchParams();
    const customerIdFromParams = queryParams.get('customerId') ?? undefined;
    const invoiceIdFromParams = queryParams.get('invoiceId') ?? undefined;
    const contractIdFromParams = queryParams.get('contractId') ?? undefined;

    const methods = useForm<CreateCreditNoteFormValues>({
      resolver: zodResolver(CreateCreditNoteFormSchema),
      defaultValues: getDefaultValues(customerIdFromParams, invoiceIdFromParams, contractIdFromParams),
    });

    return (
      <FormProvider {...methods}>
        <Component {...props} />
      </FormProvider>
    );
  };
}
